<template>
  <h3
    v-if="label"
    class="text-background-fg/70 mb-2 flex-shrink-0 text-sm font-medium"
  >
    {{ label }}
  </h3>
  <div class="grid w-full grid-cols-2 gap-2 sm:grid-cols-4">
    <template
      v-for="summaryItem in summary"
      :key="summaryItem.label"
    >
      <div
        class="bg-background ring-background-fg/8 rounded-lg p-3 shadow"
      >
        <p
          class="text-background-fg/70 mb-2 line-clamp-1 text-center text-xs font-medium"
        >
          {{ summaryItem.label }}
        </p>

        <div class="flex items-center justify-center">
          <span
            class="text-primary line-clamp-1 text-2xl font-bold"
            >{{ summaryItem.value }}</span
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { SummaryReportQuery } from "@/services/reports/retrieveSummaryReport"
const props = defineProps<{
  query: SummaryReportQuery
  label?: string
}>()

const { data: summaryData } = useSummaryReport(
  computed(() => props.query)
)
const { formatToMerchantCurrencyString } = useCurrency()

const summary = computed(() =>
  summaryData.value
    ? {
        revenue: {
          label: "Revenue",
          value: formatToMerchantCurrencyString(
            summaryData.value.revenue.total
          ),
        },
        transactions: {
          label: "Transactions",
          value: summaryData.value.orderCount.total,
        },
        averageTransactionValue: {
          label: "Average Spend",
          value: formatToMerchantCurrencyString(
            safeDiv(
              summaryData.value.revenue.total,
              summaryData.value.orderCount.total
            )
          ),
        },
        percentageCard: {
          label: "Percentage Card",
          value: `${Number(
            safeDiv(
              summaryData.value.revenue.card,
              summaryData.value.revenue.total
            )
          ).toLocaleString(undefined, {
            style: "percent",
            minimumFractionDigits: 2,
          })}`,
        },
      }
    : {
        revenue: {
          label: "Revenue",
          value: "-",
        },
        transactions: {
          label: "Transactions",
          value: "-",
        },
        averageTransactionValue: {
          label: "Average Spend",
          value: "-",
        },
        percentageCard: {
          label: "Percentage Card",
          value: "-",
        },
      }
)
</script>
